export default {
  name: "PayRecognizedPerson",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
